// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_fC","galleryItem_borderTopRadius":"c-o_fE","galleryItem__image":"c-o_fF"};